import { generateClient } from 'aws-amplify/api';
import Vue from 'vue';
import * as qlqueries from '../graphql/queries';

const client = generateClient();
const graphqlOperation = (query, variables) => ({ query, variables });
// import * as qlmutations from '../graphql/mutations';
// import * as qlsubscriptions from '../graphql/subscriptions';

const state = {
  name: 'App',
  listEvents: [],
  events: [],

  viewsSettings: {
  },
  config: {

  },
  awsExports: {},
};

const getters = {
};

const mutations = {
};

const actions = {
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
